import React from 'react';
import ReactSuperSelect from 'react-super-select';
import { Modal } from 'react-bootstrap';
import rest from 'rest';

import {PERMISSION_READ, PERMISSION_CREATE, PERMISSION_UPDATE } from "../../Utils/Global";

import PermissionCheck from '../Permissions/PermissionCheck';
import Combobox from './Combobox';

/**
* Class AdvancedCombobox
* Generic component to generate AdvancedCombobox (Combobox with populate from form button)
**/
class AdvancedCombobox extends Combobox {
  /**
  * props
  * Combobox props
  * autocommit : set to true to automatically commit data on each action
  * beforeAdd : before adding object function
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * objectClass : class name of the object's form
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
      form: "",
      cbxProps: {
        onChange: () => {},
        disabled: this.props.disabled
      }
    };

    this.openObjectForm = this.openObjectForm.bind(this);
    this.openViewObjectForm = this.openViewObjectForm.bind(this);

    this.openEditObjectForm = this.openEditObjectForm.bind(this);
    this.closeObjectForm = this.closeObjectForm.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.beforeAdd = this.beforeAdd.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  /**
  * render
  * Rendering component function : display the Combobox
  **/
  render()
{
    const viewButton =(this.props.noView==true || (!this.getValue() && !this.props.default) ) ? null :
    <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_READ}>
      <span onClick={this.openViewObjectForm} className="advanced-combobox-view grid-action glyphicon glyphicon-zoom-in"></span>
    </PermissionCheck>;


    const addButton = (this.props.disabled || this.props.disableAdd === true) ? null :
      <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_CREATE}>
        <span onClick={this.openObjectForm} className="advanced-combobox-add grid-action glyphicon glyphicon-plus"></span>
      </PermissionCheck>;

    const editButton = (this.props.disabled || this.props.withEdit !== true || (!this.getValue() && !this.props.default)) ? null :
      <PermissionCheck component={this.props.objectClass.getClassName()} permission={PERMISSION_UPDATE}>
        <span onClick={this.openEditObjectForm} className="advanced-combobox-edit grid-action glyphicon glyphicon-edit"></span>
      </PermissionCheck>;

    return(
        <span className="advanced-combobox">
          <ReactSuperSelect {...this.state.cbxProps} />
          {viewButton}
          {addButton}
          {editButton}
          <Modal show={this.state.showModal} onHide={this.closeObjectForm} bsSize="large">
            <Modal.Header closeButton>
              <Modal.Title>Ajouter à la liste</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.form}
            </Modal.Body>
          </Modal>
        </span>
    );
  }

  /**
  * getValue
  * Returns the current value
  **/
  getValue() {
    return this.refs.combobox && this.refs.combobox.state.value instanceof Array && this.refs.combobox.state.value.length > 0 ?
      this.refs.combobox.state.value[0] : null;
  }

  /**
  * getAutoCommit
  * Auto commit mode or not
  **/
  getAutoCommit() {
    return this.props.autocommit === true;
  }

  /**
  * onChange
  * Handle onChange event
  **/
  onChange(obj) {
    this.props.onChange.call(this, obj, this.refresh);
  }

  /**
  * openObjectForm
  * Open the object's form (add mode)
  **/
  openObjectForm() {
    const component = React.createElement(this.props.objectClass, {
        mode: "add",
        objectPath: this.props.path,
        data: {
          object: {}
        },
        modal: true,
        closeModal: this.closeObjectForm.bind(this),
        onAdd: this.beforeAdd
    });

    this.setState({
      showModal: true,
      form: component,
      cbxProps: this.state.cbxProps
    });
  }



openViewObjectForm() {
  const object = this.getValue();

  if(object) {
    const objectId = object[this.props.optionValueKey];

    const component = React.createElement(this.props.objectClass, {
        mode: "readonly",
        objectPath: `${this.props.path}/${objectId}`,
        data: {
          object: object
        },
        modal: true,
        closeModal: this.closeObjectForm.bind(this)
    });

    this.setState({
      showModal: true,
      form: component,
      cbxProps: this.state.cbxProps
    });
  }
}

  /**
  * openEditObjectForm
  * Open the object's form (edit mode)
  **/
  openEditObjectForm() {
    const object = this.getValue();

    if(object) {
      const objectId = object[this.props.optionValueKey];

      const component = React.createElement(this.props.objectClass, {
          mode: "edit",
          objectPath: `${this.props.path}/${objectId}`,
          data: {
            object: object
          },
          modal: true,
          closeModal: this.closeObjectForm.bind(this),
          onEdit: this.onAdd
      });

      this.setState({
        showModal: true,
        form: component,
        cbxProps: this.state.cbxProps
      });
    }
  }

  /**
  * closeObjectForm
  * Close the object's form
  **/
  closeObjectForm() {
    this.setState({
      showModal: false,
      form: "",
      cbxProps: this.state.cbxProps
    });
  }

  /**
  * beforeAdd
  * Catch the form onAdd event
  * Call beforeAdd if exists, onAdd if not
  **/
  beforeAdd(object) {
    if(this.props.beforeAdd !== undefined) {
      this.props.beforeAdd.call(this, object, this.refresh);
    } else {
      this.onAdd(object);
    }
  }

  /**
  * onAdd
  * Refreshes the combobox
  **/
  onAdd(object) {
    if(this.props.afterAdd instanceof Function) this.props.afterAdd.call(this, object);

    let state = this.state;
    state.showModal = this.props.closeOnAdd === false;
    state.form = "";
    state.cbxProps.initialValue = object;

    if(this.props.url) {
      rest({method: 'GET', path: this.props.url}).then(response => {
        let dataSource = { collection: [] };
        dataSource.collection = JSON.parse(response.entity);
        state.cbxProps.dataSource = dataSource;

        this.setState(state);
        this.onChange(state.cbxProps.initialValue);
      });
    } else {
      this.setState(state);
    }
  }

  /**
  * refresh
  * Refreshes the combobox
  **/
  refresh() {
    let state = this.state;
    state.showModal = false;
    state.form = "";

    if(this.props.url) {
      rest({method: 'GET', path: this.props.url}).then(response => {
        let dataSource = { collection: [] };
        dataSource.collection = JSON.parse(response.entity);
        state.cbxProps.dataSource = dataSource;

        this.setState(state);
      });
    } else {
      this.setState(state);
    }
  }

  /**
  * addObject
  * Add an item to the combo
  **/
  addObject(object) {
    let state = this.state;
    state.cbxProps.dataSource.collection.push(object);

    this.setState(state);
  }

  /**
  * removeObject
  * Remove an item from the combo
  **/
  removeObject(object, idKey) {
    let state = this.state;
    state.showModal = false;
    state.form = "";

    let collection = state.cbxProps.dataSource.collection;
    for(let i=0; i<collection.length; i++) {
      const obj = collection[i];

      if(obj[idKey] === object[idKey]) {
        collection.splice(i, 1);
        break;
      }
    }

    state.cbxProps.dataSource.collection = collection;
    this.setState(state);
  }

}

export default AdvancedCombobox;



// WEBPACK FOOTER //
// ./src/views/Helper/AdvancedCombobox.js